/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Overlapping_Events_TitleInputs */



/**
* | output |
* | --- |
* | "Overlapping Events" |
*
* @param {Editor_Overlapping_Events_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_overlapping_events_title = /** @type {((inputs?: Editor_Overlapping_Events_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Overlapping_Events_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Evenements qui se chevauchent")
	if (locale === "de") return /** @type {LocalizedString} */ ("Überlappende Ereignisse")
	if (locale === "it") return /** @type {LocalizedString} */ ("Eventi sovrapposti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пересекающиеся события")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eventos superpuestos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("重叠事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("重複するイベント")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अतिव्यापी घटनाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Eventos sobrepostos")
	return /** @type {LocalizedString} */ ("Overlapping Events")
});